import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  FormGroup,
  Spinner,
  CardFooter,
  Modal,
  ModalHeader,
} from "reactstrap";
import searchImg from "../assets/img/icons/search.svg";
import PickDateRange from "../components/shared/PickDateRange";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrders, updateOrder } from "store/actions/RequestActions";
import { updateOrderPaymentStatus } from "store/actions/orderActions";
import moment from "moment";
import { toast } from "react-toastify";
import OrderRangeSlider from "components/Layout/OrderRangeSlider";
import PrintBill from "components/Orders/PrintBill";
import { getRestaurantDrivers } from "store/actions/driverAction";
import Pagination from "components/shared/Pagination";
import DebouncedSearch from "components/shared/DebouncedSearch";
import { InstructionsModal } from "components/Modals/InstructionsModal";
import usePermissions from "hooks/usePermissions";
import Payment from "components/Menu/WaiterMenu/Payment";
import { clearTableData } from "store/actions/tableActions";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { OrderItemsModal } from "components/Modals/OrderItemsModal";

const WaiterOrdersResturant = () => {
  const filters = [
    { name: "All", status: "" },
    { name: "New", status: "pending" },
    { name: "Processing", status: "processing" },
    { name: "Served", status: "served" },
  ];
  const dispatch = useDispatch();
  const { restaurantOrders, orderLoader, restaurantOrdersRestData } =
    useSelector((state) => state.requests);
  const { restaurantsDetail } = useSelector((state) => state.restaurant);
  const { user } = useSelector((state) => state.auth);
  const [activeFilter, setActiveFilter] = useState(0);
  const [filterValue, setFilterValue] = useState(filters[0].status);
  const [value, setValue] = useState([0, 10000]);
  const [currentPage, setCurrentPage] = useState(0);
  const [modal, setModal] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [updatingOrder, setUpdatingOrder] = useState({});
  const [cancelLoading, setCancelLoading] = useState(false);
  const [cancelItem, setCancelItem] = useState({});
  const toggle = () => setModal(!modal);
  const [selectedNotes, setSelectedNotes] = useState([]);
  const [selectedOrderItems, setSelectedOrderItems] = useState([]);
  const [instructionsModalOpen, setInstructionsModalOpen] = useState(false);
  const [orderItemsModalOpen, setOrderItemsModalOpen] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [orderType, setOrderType] = useState("dinein");
  const { edit: editAccess, get: getAccess } = usePermissions();
  const [isOrdersLoading, setIsOrdersLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [datestate, setDateState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const startDate = moment(datestate[0].startDate).startOf("day").unix();

  const endDate = moment(datestate[0].endDate).endOf("day").unix();

  const formatCreatedAt = (createdAt) => {
    return moment.unix(createdAt._seconds).format("DD MMM, YYYY, h:mm A");
  };

  const handleSearch = (debouncedValue) => {
    setDebouncedSearch(debouncedValue);
  };

  const paymentModalToggler = () => {
    setShowPayment(!showPayment);
  };

  const confirmOrder = (paymentMethod = "", paymentRecieved = false) => {
    if (!selectedOrder?.orderId) return;

    setIsLoading(true);

    const onSuccess = () => {
      toast.success("Payment made successfully");
      setShowPayment(false);
      setIsLoading(false);

      if (paymentRecieved) {
        dispatch(clearTableData(user?.restaurantID, selectedOrder.tableNumber));
      }
    };

    const onError = (errorMessage) => {
      toast.error("Error while making payment");
      setIsLoading(false);
    };

    dispatch(
      updateOrderPaymentStatus(
        selectedOrder.orderId,
        paymentMethod,
        paymentRecieved,
        onSuccess,
        onError
      )
    );

    return selectedOrder.orderId;
  };

  const handleUpdateStatus = async (e, item, status) => {
    e.preventDefault();
    setUpdatingOrder({ ...updatingOrder, [item.id]: true });
    try {
      if (status !== "ready") {
        await dispatch(
          updateOrder(item, status, () => {
            setUpdatingOrder({ ...updatingOrder, [item.id]: false });
          })
        );
      }
    } catch (err) {
      console.error(err.message);
      setUpdatingOrder({ ...updatingOrder, [item.id]: false });
    }
  };
  const handleCancelOrder = async (item) => {
    try {
      setCancelLoading(true);
      setUpdatingOrder({ ...updatingOrder, [item.id]: true });
      await dispatch(
        updateOrder(item, "cancelled", () => {
          dispatch(clearTableData(item?.restaurantID, item?.tableNumber));
          setUpdatingOrder({ ...updatingOrder, [item.id]: false });
          setCancelLoading(false);
          toggle();
        })
      );
    } catch (err) {
      console.error(err.message);
      setCancelLoading(false);
      setUpdatingOrder({ ...updatingOrder, [item.id]: false });
    }
  };

  useEffect(() => {
    dispatch(getRestaurantDrivers(user?.restaurantID));
  }, [user?.restaurantID, dispatch]);

  useEffect(() => {
    setIsOrdersLoading(true);
    let unsubscribe;

    const loadOrders = async () => {
      unsubscribe = await dispatch(
        getAllOrders(
          debouncedSearch,
          user?.id,
          currentPage,
          startDate,
          endDate,
          value[0],
          value[1],
          orderType,
          filterValue,
          () => {
            setIsOrdersLoading(false);
          },
          true
        )
      );
    };

    loadOrders();

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [
    currentPage,
    debouncedSearch,
    startDate,
    dispatch,
    endDate,
    value,
    user?.restaurantID,
    orderType,
    filterValue,
  ]);

  useEffect(() => {
    setCurrentPage(0);
  }, [debouncedSearch]);
  return (
    <div className="orders pb-4 pt-0 pt-md-6">
      <Container className="mt-5 pt-2" fluid>
        <Card className="p-3 rounded-lg">
          <Row className="row mt-2">
            <Col>
              <h2 className="mb-1">Orders</h2>
              <p className="text-muted">
                Manage your billing and payment details
              </p>
            </Col>
          </Row>

          <Row className="mx-2 mt-0 pt-0 d-lg-flex filters-row">
            {filters.map((filter, index) => {
              const isActive = activeFilter === index;
              const isDisabled = isOrdersLoading;

              return (
                <div
                  key={index}
                  className={`px-3 py-1 filter ${
                    isDisabled ? "filter-disabled" : ""
                  }`}
                  style={{
                    borderBottom: isActive
                      ? `2px solid ${restaurantsDetail?.adminColor}`
                      : "none",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    opacity: isDisabled ? 0.5 : 1,
                  }}
                  onClick={() => {
                    if (isDisabled) return;
                    setCurrentPage(0);
                    setActiveFilter(index);
                    setFilterValue(filter.status);
                  }}
                >
                  <p
                    className="mb-0 text-capitalize"
                    style={{
                      color: isActive
                        ? `${restaurantsDetail?.adminColor}`
                        : "#64748b",
                    }}
                  >
                    {filter.name}
                  </p>
                </div>
              );
            })}
          </Row>

          <Row className="my-3 mx-2">
            <Col sm="12" md="6" lg="4">
              <FormGroup className="orders__form_group">
                <img src={searchImg} alt="search" />
                <DebouncedSearch
                  placeholder="Search by customer name, order name...."
                  onSearch={handleSearch}
                />
              </FormGroup>
            </Col>

            <Col sm="12" md="6" lg="4" className="my-2 my-lg-0">
              <OrderRangeSlider
                value={value}
                setValue={(newValue) => {
                  setTimeout(() => {
                    setValue(newValue);
                  }, 2000);
                }}
                setCurrentPage={setCurrentPage}
                adminColor={restaurantsDetail?.adminColor}
              />
            </Col>

            <Col sm="12" md="6" lg="4">
              <PickDateRange
                setDateState={setDateState}
                datestate={datestate}
              />
            </Col>
          </Row>

          <Row className="justify-content-around">
            <Col
              md={12}
              className="orders-table__col2 px-0"
              style={{
                "--scrollbar-color": restaurantsDetail?.adminColor || "#cf327b",
              }}
            >
              {getAccess ? (
                <>
                  <Table
                    className="align-items-center table-flush mt-3 orders-table"
                    responsive
                  >
                    <thead className="thead-light">
                      <tr>
                        <th scope="col" className="text-center">
                          Custome Name
                        </th>

                        <th scope="col" className="text-center">
                          Table no.
                        </th>

                        <th
                          scope="col"
                          style={{
                            width: "150px",
                          }}
                        >
                          Order
                        </th>

                        <th scope="col" className="text-center">
                          Instructions
                        </th>

                        <th scope="col" className="text-center">
                          CreatedAt
                        </th>
                        <th scope="col" className="text-center">
                          Type
                        </th>
                        <th scope="col" className="text-center">
                          Status
                        </th>

                        <th scope="col" className="text-center">
                          Payment
                        </th>

                        <th scope="col" className="text-center">
                          Amount
                        </th>
                        {editAccess && (
                          <th scope="col" className="text-center">
                            Actions
                          </th>
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {orderLoader || isOrdersLoading ? (
                        <tr>
                          <td colSpan="100%" className="text-center py-5">
                            <Spinner size="lg" color="primary" />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {restaurantOrders?.length > 0 ? (
                            <>
                              {restaurantOrders?.map((item, index) => (
                                <tr key={index}>
                                  <td className="text-center">
                                    {item?.customerName}
                                  </td>

                                  <td className="text-center">
                                    {item?.tableNumber}
                                  </td>

                                  <td>
                                    <Button
                                      color="primary"
                                      size="sm"
                                      onClick={() => {
                                        setSelectedOrderItems(item?.order);
                                        setOrderItemsModalOpen(true);
                                      }}
                                    >
                                      View
                                    </Button>
                                  </td>

                                  <td className="text-center">
                                    <>
                                      {item?.order?.some(
                                        (order) => order?.notes?.length > 1
                                      ) ? (
                                        <Button
                                          color="primary"
                                          size="sm"
                                          onClick={() => {
                                            const notesArray =
                                              item?.order?.filter(
                                                (order) =>
                                                  order?.notes?.length > 1
                                              );
                                            setSelectedNotes(notesArray);
                                            setInstructionsModalOpen(true);
                                          }}
                                        >
                                          View
                                        </Button>
                                      ) : (
                                        <span className="text-capitalize">
                                          ...
                                        </span>
                                      )}
                                    </>
                                  </td>

                                  <td className="text-center">
                                    {formatCreatedAt(item?.createdAt)}
                                  </td>

                                  <td className="text-center">
                                    <span
                                      style={{
                                        textTransform: "uppercase",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {item?.orderType}
                                    </span>
                                  </td>

                                  <td className="text-center">
                                    <span
                                      className={`status__${item?.status} text-capitalize`}
                                    >
                                      {item?.status}
                                    </span>
                                  </td>

                                  <td className="text-center">
                                    {item?.paymentMethod}
                                  </td>

                                  <td className="text-center">
                                    {item?.currency || "USD"}&nbsp;
                                    {item?.finalPrice
                                      ? item?.finalPrice
                                      : item?.totalAmount}
                                  </td>

                                  {editAccess || user?.type === "restaurant" ? (
                                    <td>
                                      <div
                                        className="d-flex justify-content-center align-items-center w-100 h-100"
                                        style={{ minHeight: "100%" }}
                                      >
                                        {(item?.status === "pending" ||
                                          item?.status === "refunded") && (
                                          <Button
                                            size="sm"
                                            className="mx-1 w-100 orders-table__pending"
                                            disabled={
                                              item?.status === "refunded" ||
                                              updatingOrder[item?.id]
                                            }
                                            onClick={(e) =>
                                              item?.status === "pending" &&
                                              handleUpdateStatus(
                                                e,
                                                item,
                                                "processing"
                                              )
                                            }
                                          >
                                            Move to Processing
                                          </Button>
                                        )}

                                        {item?.status === "processing" && (
                                          <Button
                                            size="sm"
                                            className="mx-1 w-100 orders-table__process"
                                            disabled={updatingOrder[item?.id]}
                                            onClick={(e) =>
                                              handleUpdateStatus(
                                                e,
                                                item,
                                                "served"
                                              )
                                            }
                                          >
                                            Move to Served
                                          </Button>
                                        )}

                                        {item?.status === "served" && (
                                          <Button
                                            size="sm"
                                            className="mx-1 w-100 orders-table__paid"
                                            onClick={() => {
                                              setSelectedOrder(item);
                                              paymentModalToggler();
                                            }}
                                            disabled={updatingOrder[item?.id]}
                                          >
                                            Proceed to Payment
                                          </Button>
                                        )}

                                        {item?.status === "completed" && (
                                          <Button
                                            size="sm"
                                            className="mx-1 w-100 orders-table__paid"
                                            disabled={true}
                                          >
                                            Completed
                                          </Button>
                                        )}

                                        {(item?.status === "pending" ||
                                          item?.status === "processing" ||
                                          item?.status === "cancelled") && (
                                          <Button
                                            size="sm"
                                            className="mx-1 w-100 orders-table__cancelled"
                                            disabled={
                                              !(
                                                item?.status === "pending" ||
                                                item?.status === "processing"
                                              ) || updatingOrder[item?.id]
                                            }
                                            onClick={() => {
                                              setCancelItem(item);
                                              toggle();
                                            }}
                                          >
                                            {item?.status === "cancelled"
                                              ? "Cancelled"
                                              : "Cancel Order"}
                                          </Button>
                                        )}

                                        <PrintBill
                                          order={item}
                                          restaurantCurrency={item?.currency}
                                          disabled={updatingOrder[item?.id]}
                                        />
                                      </div>
                                    </td>
                                  ) : null}
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colSpan="100%" className="text-center py-5">
                                No Order Added
                              </td>
                            </tr>
                          )}
                        </>
                      )}
                    </tbody>
                  </Table>
                </>
              ) : (
                <Row className="py-4 justify-content-center align-items-center">
                  You don't have the permission to access the page
                </Row>
              )}

              <CardFooter className="py-4">
                <Pagination
                  currentPage={currentPage}
                  totalPages={restaurantOrdersRestData?.nbPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </CardFooter>
            </Col>
          </Row>
        </Card>
      </Container>

      <Modal isOpen={showPayment} toggle={paymentModalToggler} size="xl">
        <ModalHeader
          toggle={paymentModalToggler}
          className="align-items-center border-bottom py-3"
        >
          Make Payment
        </ModalHeader>
        <Payment
          setShowPayment={setShowPayment}
          totalAmount={selectedOrder?.finalPrice || 0}
          confirmOrder={confirmOrder}
          loading={isLoading}
          showBackButton={false}
        />
      </Modal>

      <ConfirmationModal
        title="Cancel Order"
        text="Are you sure you want to cancel the order?"
        isOpen={modal}
        toggle={toggle}
        isLoading={cancelLoading}
        onConfirmation={() => handleCancelOrder(cancelItem)}
      />

      <InstructionsModal
        isOpen={instructionsModalOpen}
        toggle={() => setInstructionsModalOpen(false)}
        notes={selectedNotes}
      />
      <OrderItemsModal
        isOpen={orderItemsModalOpen}
        toggle={() => setOrderItemsModalOpen(false)}
        orderItems={selectedOrderItems}
      />
    </div>
  );
};

export default WaiterOrdersResturant;
